import { Pais } from './pais.model';

export class Telefono {

    id: number;
    numero: string;
    interno: string;
    prefijo: string;
    tipo: string;
    codigoPais: string;
    numeroCompleto: string;
    numeroCountryCode: string;



    /**
     * Constructor
     *
     * @param telefono
     */
    constructor(telefono)
    {
        {
            this.id = telefono.id || null;
            this.prefijo = telefono.prefijo || '';
            this.numero = telefono.numero || '';
            this.interno = telefono.interno || '';
            this.tipo = telefono.tipo || 'FIJO';
            this.codigoPais = telefono.codigoPais || '';
            this.numeroCompleto = telefono.numeroCompleto || '';
            this.numeroCountryCode = telefono.numeroCountryCode || '';
            
        }
    }
}
